export class FacetValue {
    public name: string;
    public Value: string;
    public Count: number;
}
